/*
  Project: Vivafloors
  Author: Thomas
 */

// Helpers
function getParameterByName(name, url = window.location.href) {
  // eslint-disable-next-line no-useless-escape
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}


// Function te recreate the cart with Ajax post call sending the product id's in JSON
function requestCartChange(selector, selectorContainer, dealer = false, button) {
  const container = document.querySelector(selectorContainer);
  const options = document.querySelectorAll(selector);
  let checkedItems = [];

  for (var i = 0; i < options.length; i++) {
    if (dealer && options[i].selected === true) {
      checkedItems.push(options[i].value)
    }
    if (!dealer && options[i].checked === true) {
      checkedItems.push(options[i].value)
    }
  }

  // jQuery object van de knop maken
  const $button = jQuery(button);

  // Zorg dat de juiste data attribute bestaat
  if ($button.length) {
    const id = $button.data('id') || $button.attr('value');
    if (id) {
      $button.attr('data-product_id', id);
    }
  }

  // Run woocommerce_ajax_add_to_cart from functions.php
  jQuery.ajax({
    type: 'POST',
    dataType: 'json',
    url: window.location.protocol + '//' + window.location.host + '/wp-admin/admin-ajax.php',
    data: {
      action: 'woocommerce_ajax_add_to_cart',
      product_ids: checkedItems,
    },
    beforeSend: function () {
      container.classList.add('loading')
    },
    complete: function () {
      container.classList.remove('loading')
    },
    success: function (response) {
      if (response.error) {
        console.error(response.error);
      } else {
        jQuery(document.body).trigger('added_to_cart', [
          response.fragments,
          response.cart_hash,
          $button
        ]);
      }
    },
    error: function (xhr, status, error) {
      console.error('AJAX request failed:', status, error);
      alert('AJAX request failed: ' + error);
    }
  });
}



/* Set a maximum of favorited items selections */
let checkSelected = function (group, selector, dealer = false) {
  if(group.length <= 0 && !selector && !dealer ) {
    return;
  }

  const checkBoxMessageMax = selector ? document.querySelector(`${selector}__message_max`) : null;
  const checkBoxMessageMin = selector ? document.querySelector(`${selector}__message_min`) : null;
  var limit = 3;
  var checkedcount = 0;

  if (dealer) {
    const selected = document.querySelectorAll('#dealer_products option:checked');
    checkedcount = selected.length;
  } else {
    for (let i = 0; i < group.length; i++) {
      if (group[i].checked) {
        checkedcount += 1;
      }
    }
  }

  if(checkBoxMessageMin) {
    checkBoxMessageMin.classList.remove('show');
  }

  if (checkedcount > limit) {
    if (checkBoxMessageMax) checkBoxMessageMax.classList.add('show');
    return true;
  } else if (checkedcount < limit) {
    if (checkBoxMessageMax) checkBoxMessageMax.classList.remove('show');
  } else if (checkedcount === 0) {
    if (checkBoxMessageMin) checkBoxMessageMin.classList.add('show');
  }

  return false;
}

// Check first 3 items and run requestCartChange if so
function initFavoritesValidation(selector) {
  const checkBoxGroup = document.querySelectorAll(selector);
  if (checkBoxGroup.length === 0) return;

  for (var i = 0; i < checkBoxGroup.length; i++) {

    // Check the first 3 items by default
    if (i < 3) {
      checkBoxGroup[i].checked = true;
    }

    checkBoxGroup[i].onclick = function () {
      if (checkSelected(checkBoxGroup, selector)) {
        this.checked = false;
      } else {
        requestCartChange('.c-favorite-checkbox', '.js-favorite-checkboxes', false, this);
      }
    }
  }

  checkSelected(checkBoxGroup, selector);
}

function initDealerValidation(messageSelector) {

  const optionsGroup = document.querySelectorAll('#dealer_products option');

  for (var i = 0; i < optionsGroup.length; i++) {

    jQuery(optionsGroup[i]).on('mouseup', function () {
      if (checkSelected(optionsGroup, messageSelector, true)) {
        this.selected = false;
        // e.preventDefault();
      } else {
        requestCartChange('#dealer_products option', '.woocommerce-billing-fields__field-wrapper', true, this);
      }
    });
  }

  checkSelected(optionsGroup, messageSelector, true);
}


// Init on checkout page load
jQuery(function($) {
  if (!document.querySelector('.woocommerce-checkout')) return;
  const dealerform = getParameterByName('dealerform');
  if (dealerform === 'true') {
    initDealerValidation('.woocommerce-billing-fields__field-wrapper');
  } else {
    initFavoritesValidation('.c-favorite-checkbox');

  }
});


// Add Scroll to on thankyou page
jQuery(document).ready(function () {
  if (jQuery('.woocommerce-order')[0]) {
    jQuery('html,body').animate({
      scrollTop: jQuery('.woocommerce-order').offset().top - 200
    }, 1500);
  }
});



// WEBPACK FOOTER //
// ./src/scripts/modules/checkout.js